module.exports = __webpack_public_path__ + "img/voicemail.8b805e69.svg";